import { Reducer } from 'redux';
import produce from 'immer';

import exhaustivnessCheck from 'common/utils/exhaustivnessCheck';
import { ConfigState, defaultConfigState } from './states';
import { ConfigActions } from './actions';

export const configReducer: Reducer<ConfigState, ConfigActions> = (
  state = defaultConfigState,
  action
) =>
  produce(state, (draft) => {
    switch (action.type) {
      case 'config/started':
        draft.pending = true;
        return;

      case 'config/finished':
        draft.pending = false;
        draft.config = action.config;
        draft.error = action.error;
        return;

      default:
        exhaustivnessCheck(action);
    }
  });
